import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/schedule', label: 'Schedule' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md h-16' : 'bg-white/95 h-20'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
        <Link to="/" className="flex items-center gap-4">
          <img 
            src="https://static.readdy.ai/image/57253257ce2fc83925052891bf004756/e7a785bbdafc682c9f4e03fdd78b3719.jpeg" 
            alt="LG Concrete Pumping & Stone LLC" 
            className="h-12 w-auto object-contain"
          />
          <div className="hidden md:block">
            <div className="text-xl font-bold text-black leading-tight">
              LG CONCRETE PUMPING & STONE
            </div>
            <div className="text-xs text-gray-600">Otto, NC</div>
          </div>
        </Link>

        <div className="h-8 w-1 bg-yellow-500 hidden lg:block"></div>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-base font-medium transition-colors relative pb-1 whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-black'
                  : 'text-gray-700 hover:text-yellow-500'
              }`}
            >
              {link.label}
              {location.pathname === link.path && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-yellow-500"></span>
              )}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:8286341304"
            className="flex items-center gap-2 text-base font-medium text-black whitespace-nowrap"
          >
            <i className="ri-phone-fill text-yellow-500"></i>
            (828) 634-1304
          </a>
          <Link
            to="/services"
            className="bg-yellow-500 text-black px-6 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-all whitespace-nowrap cursor-pointer"
          >
            GET QUOTE
          </Link>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden flex flex-col gap-1.5 cursor-pointer"
        >
          <span className="w-7 h-0.5 bg-yellow-500 transition-all"></span>
          <span className="w-7 h-0.5 bg-yellow-500 transition-all"></span>
          <span className="w-7 h-0.5 bg-yellow-500 transition-all"></span>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col p-6 gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-base font-medium py-2 ${
                  location.pathname === link.path
                    ? 'text-yellow-500'
                    : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:8286341304"
              className="flex items-center gap-2 text-base font-medium text-black py-2"
            >
              <i className="ri-phone-fill text-yellow-500"></i>
              (828) 634-1304
            </a>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className="bg-yellow-500 text-black px-6 py-3 rounded-lg font-semibold text-center cursor-pointer"
            >
              GET QUOTE
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;